import { isHouseholdCatalogsResponse, isMemberHouseholdsResponse, } from '@urbanik/api-contracts';
export class MemberHouseholdApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
    }
}
async function call(url, guard, init) {
    let r;
    try {
        r = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
            },
        });
    }
    catch {
        throw new MemberHouseholdApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const p = await r.json().catch(() => null), message = p && typeof p.message === 'string' ? p.message : 'No pudimos completar la solicitud.';
    if (!r.ok) {
        const kind = r.status === 400
            ? 'validation'
            : r.status === 401
                ? 'unauthorized'
                : r.status === 403
                    ? 'forbidden'
                    : r.status === 404
                        ? 'not-found'
                        : r.status === 409
                            ? 'conflict'
                            : 'unavailable';
        throw new MemberHouseholdApiError(kind, message);
    }
    if (!guard(p))
        throw new MemberHouseholdApiError('invalid', 'El contrato de hogar es inválido.');
    return p;
}
export const getMemberHouseholds = (base, id, signal) => call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/households`, isMemberHouseholdsResponse, { signal: signal ?? null });
export const getHouseholdCatalogs = (base, signal) => call(`${base.replace(/\/$/, '')}/identity/member-profile/household-catalogs`, isHouseholdCatalogsResponse, { signal: signal ?? null });
export const saveMemberHousehold = (base, id, input) => call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/households`, isMemberHouseholdsResponse, { method: 'PUT', body: JSON.stringify(input) });
